import React from 'react';
import { Theme, ActionBar, ActionBarSize } from '@routific/hive';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ZIndex from '../../shared/CSS/ZIndex';
import { DEFAULT_BORDER_RADIUS } from '../../../constants';
import Content from './Content';

interface MapActionBarProps {
  onClear: (() => void) | undefined
  isVisible: boolean;
}

const MapActionBarWrapper = styled.div`
  position: absolute;
  z-index: ${ZIndex.MAX};
  bottom: ${Theme.Spacing.smSpacing};
  left: 50%;
  border-radius: ${DEFAULT_BORDER_RADIUS};
  transform: translateX(-50%);
  display: flex;
  box-sizing:border-box;
`;

const MapActionBar: React.FC<MapActionBarProps> = ({ onClear, isVisible }) => {
  const { t } = useTranslation('components');

  return (
    <MapActionBarWrapper>
      <ActionBar
        content={<Content />}
        onClear={onClear}
        size={ActionBarSize.SMALL}
        clearButtonText={t('ordersForm.actionBar.cancel')}
        buttonStyle={{ color: Theme.Colors.gray0 }}
        isVisible={isVisible}
      />
    </MapActionBarWrapper>
  );
};

export default MapActionBar;
